import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/config/public").then((r) => setConfig(r.data)).catch(() => setConfig({}));
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, refresh, logout, config }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
